import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Contact from "../components/contact";
import Hero from "../commercial/components/hero";
import TriCards from "../commercial/components/triCards";
import PageShell from "../components/pageShell";
import ZigZag from "../commercial/components/zigzag";
import BeforeAfter from "../commercial/components/beforeAfter";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const RoofCleaningPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Roof Cleaning - Flyby Shine</title>
                        <meta name="description" content="Elevate Your Home and Property's Appeal with our Drone-assisted Roof Cleaning Service." />
                        <meta name="keywords" content="Roof Cleaning, Roof cleaning services, residential roof cleaning, home roof cleaning, hygienic roof cleaning, expert roof cleaning services, safe roof cleaning, thorough roof cleaning, professional roof cleaning, reliable roof cleaning, top-quality roof cleaning, roof cleaning services, roof cleaning solutions, roof cleaning experts" />
                        <meta property="og:image" content="/assets/roofcleaning.png" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Residential & Home'}
                    title={'Roof Cleaning'}
                    description={`Elevate Your Home and Property's Appeal with our Drone-assisted Roof Cleaning Service.`}
                    banner={{ image: '/assets/roofcleaning.png', alt: 'a man cleaning the roof' }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/residential-home'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Reach High Areas Safely'}
                        heading={{ image: '/assets/upwardIcon.svg', alt: 'about' }}
                        description={'With our state-of-the-art drone technology, we offer safe, efficient, and thorough cleaning solutions for roofs.'}

                    />
                    <TriCards.Card
                        title={'FAA Licensed Pilots'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'about' }}
                        description={'Our team of FAA-licensed pilots brings exceptional expertise and reliability, ensuring top safety and quality standards in every project.'}
                    />
                    <TriCards.Card
                        title={'Faster Cleanings'}
                        heading={{ image: '/assets/boltIcon.svg', alt: 'about' }}
                        description={'Drones can clean large surface areas much faster than traditional methods, reducing the cleaning time.'}
                    />
                </TriCards>
                <BeforeAfter
                    title={"Before And After"}
                    description={"Wash away the dirt and grime from your roof with our advanced drone-assisted cleaning services."}
                    subTitle={"Roof Cleaning"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Efficient & Fast Cleaning</li>
                                <li><i className="material-icons">check_circle_outline</i>Safe: No more ladders or platforms</li>
                                <li><i className="material-icons">check_circle_outline</i>Reach Inaccessible Areas</li>
                            </ul>
                        </div>
                    }
                    images={[{
                        firstImage: {
                            imageUrl: '/assets/homeAfter.jpg',
                        },
                        secondImage: {
                            imageUrl: '/assets/homeBefore.jpg',
                        }

                    }
                    ]}

                />

                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/droneHouse.jpg', alt: 'nationwide about us image' }}
                        title={'Minimized Risk of Property Damage'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'protecting your property icon' }}
                        description={'Our drone cleaning technology allows for controlled pressure application tailored to different surfaces, minimizing the risk of damage to your valuable property.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/drone2a.png', alt: 'drone displayed' }}
                        title={'Customized Approach'}
                        heading={{ image: '/assets/flexible.svg', alt: 'flexibility about us icon' }}
                        description={'Our drones offer the flexibility to adapt to various surfaces and architectural styles, whether it’s high-rise office buildings, complex industrial sites, or delicate historical structures. '}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/home.mp4',

                        }}
                        title={'Prevent Home Damage'}
                        heading={{ image: '/assets/star.svg', alt: 'faster bolt icon' }}
                        description={'Over time, dirt, mold, and mildew can cause significant damage to your home’s exterior, leading to costly repairs. '}
                    />
                </ZigZag>
                <Contact />
            </PageShell>
            <style>
                {
                    `
                    .zigzag {
                    margin-top: 150px
                    }
                    `
                }
            </style>

        </>
    )
}

export default RoofCleaningPage
